import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=230f973c&scoped=true&"
import script from "./accordion-item.vue?vue&type=script&lang=js&"
export * from "./accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=230f973c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f973c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230f973c')) {
      api.createRecord('230f973c', component.options)
    } else {
      api.reload('230f973c', component.options)
    }
    module.hot.accept("./accordion-item.vue?vue&type=template&id=230f973c&scoped=true&", function () {
      api.rerender('230f973c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/accordion-item.vue"
export default component.exports